var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',[_c('v-avatar',{attrs:{"size":"60"}},[_c('img',{staticClass:"mr-2",attrs:{"alt":"Logo","src":_vm.icon}})]),_vm._v(" "+_vm._s(_vm.title)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }